// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.organic-range-picker {
  display: flex;
  gap: 12px;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: end;
}

.organic-range-picker__control {
  width: 200px !important;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #ccd6e3;
  background: #ffffff;
  color: #0f172a;
  font-size: 13px;
  padding: 0 16px;
  box-shadow: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.organic-range-picker__control:hover,
.organic-range-picker__control.ant-picker-focused {
  border-color: #c7d1df !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
}

.organic-range-picker__control.ant-picker-focused,
.organic-range-picker__control.ant-picker-status-success.ant-picker-focused,
.organic-range-picker__control.ant-picker-focused:hover {
  border-color: #cfd8e3 !important;
  box-shadow: 0 0 0 3px rgba(207, 216, 227, 0.18) !important;
}

.organic-range-picker__control .ant-picker-input > input {
  font-size: 13px;
  color: #0f172a;
}

.organic-range-picker__control .ant-picker-input > input::placeholder {
  color: #64748b;
}

.organic-range-picker__control .ant-picker-suffix {
  color: #9aa4b2;
}

.dashboard-date-picker {
  width: 200px !important;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #ccd6e3;
  background: #ffffff;
  color: #0f172a;
  font-size: 14px;
  padding: 0 16px;
  box-shadow: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.dashboard-date-picker:hover,
.dashboard-date-picker.ant-picker-focused {
  border-color: #c7d1df !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
}

.dashboard-date-picker.ant-picker-focused,
.dashboard-date-picker.ant-picker-status-success.ant-picker-focused,
.dashboard-date-picker.ant-picker-focused:hover {
  border-color: #cfd8e3 !important;
  box-shadow: 0 0 0 3px rgba(207, 216, 227, 0.18) !important;
}

.dashboard-date-picker .ant-picker-input > input {
  font-size: 14px;
  color: #0f172a;
}

.dashboard-date-picker .ant-picker-input > input::placeholder {
  color: #64748b;
}

.dashboard-date-picker .ant-picker-suffix {
  color: #9aa4b2;
}

.dashboard-date-dropdown .ant-picker-panel-container {
  width: 290px !important;
  min-width: 240px !important;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.organic-range-picker__dropdown .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
.organic-range-picker__dropdown .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
  background: #0f4a97;
  border-radius: 999px;
}

.organic-range-picker__dropdown .ant-picker-cell-in-view.ant-picker-cell-in-range::before {
  background: rgba(15, 74, 151, 0.12);
}

.organic-range-picker__dropdown .ant-picker-content {
  font-size: 12px;
}

@media (max-width: 900px) {
  .organic-range-picker {
    flex-wrap: wrap;
  }
}
@media (max-width: 600px) {
  .organic-range-picker {
    width: 100%;
  }
  .organic-range-picker__control {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/dashboards/organicMedia/components/Tabs/OrganicDateRangePicker.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,0DAAA;AACF;;AAEA;;EAEE,gCAAA;EACA,uDAAA;AACF;;AAEA;;;EAGE,gCAAA;EACA,0DAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,0DAAA;AACF;;AAEA;;EAEE,gCAAA;EACA,uDAAA;AACF;;AAEA;;;EAGE,gCAAA;EACA,0DAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,0CAAA;AACF;;AAEA;;EAEE,mBAAA;EACA,oBAAA;AACF;;AAEA;EACE,mCAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE;IACE,eAAA;EACF;AACF;AAEA;EACE;IACE,WAAA;EAAF;EAGA;IACE,sBAAA;EADF;AACF","sourcesContent":[".organic-range-picker {\n  display: flex;\n  gap: 12px;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: end;\n}\n\n.organic-range-picker__control {\n  width: 200px !important;\n  height: 44px;\n  border-radius: 8px;\n  border: 1px solid #ccd6e3;\n  background: #ffffff;\n  color: #0f172a;\n  font-size: 13px;\n  padding: 0 16px;\n  box-shadow: none;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.organic-range-picker__control:hover,\n.organic-range-picker__control.ant-picker-focused {\n  border-color: #c7d1df !important;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;\n}\n\n.organic-range-picker__control.ant-picker-focused,\n.organic-range-picker__control.ant-picker-status-success.ant-picker-focused,\n.organic-range-picker__control.ant-picker-focused:hover {\n  border-color: #cfd8e3 !important;\n  box-shadow: 0 0 0 3px rgba(207, 216, 227, 0.18) !important;\n}\n\n.organic-range-picker__control .ant-picker-input > input {\n  font-size: 13px;\n  color: #0f172a;\n}\n\n.organic-range-picker__control .ant-picker-input > input::placeholder {\n  color: #64748b;\n}\n\n.organic-range-picker__control .ant-picker-suffix {\n  color: #9aa4b2;\n}\n\n.dashboard-date-picker {\n  width: 200px !important;\n  height: 44px;\n  border-radius: 8px;\n  border: 1px solid #ccd6e3;\n  background: #ffffff;\n  color: #0f172a;\n  font-size: 14px;\n  padding: 0 16px;\n  box-shadow: none;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.dashboard-date-picker:hover,\n.dashboard-date-picker.ant-picker-focused {\n  border-color: #c7d1df !important;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;\n}\n\n.dashboard-date-picker.ant-picker-focused,\n.dashboard-date-picker.ant-picker-status-success.ant-picker-focused,\n.dashboard-date-picker.ant-picker-focused:hover {\n  border-color: #cfd8e3 !important;\n  box-shadow: 0 0 0 3px rgba(207, 216, 227, 0.18) !important;\n}\n\n.dashboard-date-picker .ant-picker-input > input {\n  font-size: 14px;\n  color: #0f172a;\n}\n\n.dashboard-date-picker .ant-picker-input > input::placeholder {\n  color: #64748b;\n}\n\n.dashboard-date-picker .ant-picker-suffix {\n  color: #9aa4b2;\n}\n\n.dashboard-date-dropdown .ant-picker-panel-container {\n  width: 290px !important;\n  min-width: 240px !important;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n}\n\n.organic-range-picker__dropdown .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,\n.organic-range-picker__dropdown .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {\n  background: #0f4a97;\n  border-radius: 999px;\n}\n\n.organic-range-picker__dropdown .ant-picker-cell-in-view.ant-picker-cell-in-range::before {\n  background: rgba(15, 74, 151, 0.12);\n}\n\n.organic-range-picker__dropdown .ant-picker-content {\n  font-size: 12px;\n}\n\n@media (max-width: 900px) {\n  .organic-range-picker {\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 600px) {\n  .organic-range-picker {\n    width: 100%;\n  }\n\n  .organic-range-picker__control {\n    width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
